import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router";
import { decryptAEStoString } from "../../utils/utilities";
import { ROUTES } from "./url-constant";

const PublicRoutes = ({ component }) => {
  let location = useLocation(),
    rawAccessToken = useSelector((state) => state.accessToken.value);
  const { value } = useSelector((state) => state?.loggedUser);
  rawAccessToken = rawAccessToken
    ? decryptAEStoString(rawAccessToken)
    : rawAccessToken;

  if (value?.applicationExist === true && rawAccessToken) {
    return (
      <Navigate
        to={ROUTES.UserProfile?.MY_APPLICATION}
        state={{ from: location }}
        replace
      />
    )
  } else if (value?.applicationExist === false && rawAccessToken) {
    return (
      <Navigate
        to={ROUTES.UserProfile?.DASHBOARD}
        state={{ from: location }}
        replace
      />
    )
  }


  return component;
};

export default PublicRoutes;
